import React, { useState } from 'react'
import { useFetcher } from '../../../hooks/fetcher'
import ReferralTableContainer from '../ReferralTableContainer'
import { RefferalSection } from '../styles'

const ReferralHistory = () => {
	const { data: result } = useFetcher('/referral/users')
	let data = []

	if (result?.result?.result) {
		data = result.result.result
	}

	const [tab, setTab] = useState('all')
	const menuList = [
		'all',
		'registered',
		'deposited',
		'traded',
		'qualifiedReferess',
		'notQualified',
		'pastReferee',
	]
	return (
		<RefferalSection>
			<ReferralTableContainer
				title={'referralHistory'}
				data={data}
				menuList={menuList}
				tab={tab}
				setTab={setTab}
			/>
		</RefferalSection>
	)
}

export default ReferralHistory
